<template>
    <div class="sms">
        <MultiSelect v-model="selectedPhones" :options="selectPhones" optionLabel="name"
            placeholder="База номеров" @change="selectPhonesToSrt()" />

        <FloatLabel class="label" variant="on">
            <Textarea id="phones" v-model="phones" rows="7" cols="70"></Textarea>
            <label for="phones">Список телефонов</label>
        </FloatLabel>

        <FloatLabel class="label" variant="on">
            <Textarea id="message" v-model="message" rows="7" cols="70"></Textarea>
            <label for="message">Сообщение</label>
        </FloatLabel>

        <div>
            <Checkbox v-model="tinyurl" binary :true-value="'1'" :false-value="'0'" />
            <label>Сократить ссылки</label>
        </div>

        <ButtonVue @click="getSmsPrice()">Рассчитать</ButtonVue>

        <DataTable :value="price" tableStyle="min-width: 50rem">
            <ColumnTable field="cost" header="Цена"></ColumnTable>
            <ColumnTable field="cnt" header="Количество СМС"></ColumnTable>
        </DataTable>
    </div>
</template>

<script>
import axios from 'axios';
import MultiSelect from 'primevue/multiselect';
import Checkbox from 'primevue/checkbox';
import Textarea from 'primevue/textarea';

export default {
    components: {
        MultiSelect,
        Checkbox,
        Textarea,
    },
    data() {
        return {
            phones: '',
            selectPhones: [],
            selectedPhones: [],
            message: '',
            tinyurl: '0',
            price: [{
                id: 1,
                cost: 0,
                cnt: 0
            }]
        }
    },
    mounted: function() {
        this.getPhones();
    },
    methods: {
        async getPhones() {
            const response = await axios.get('https://ncht.bz/api/sms/get-phones');
            const data = await response.data;
            this.selectPhones = data;
        },
        async getSmsPrice() {
            let data;
            const selectedPhones = this.selectPhonesToSrt();
            if (this.phones != '' && this.isStrictPhoneList) {
                data = this.phones;
                if (selectedPhones != '') {
                    data += ', ' + selectedPhones;
                }
            } else {
                if (selectedPhones != '') {
                    data = selectedPhones;
                }
            }
            const response = await axios.post(`https://ncht.bz/api/sms/get-price`,
                {
                    "phones": data,
                    "message": this.message,
                    "tinyurl": this.tinyurl
                }
            );
            //const data = await response.data;
            this.price = [await response.data];
        },
        selectPhonesToSrt() {
            if (this.selectedPhones) {
                let data = '';
                this.selectedPhones.forEach((element) => {
                    data += element.phone + ', ';
                })
                data = data.slice(0, -2);
                return data
            } else {
                return ''
            }
        }
    },
    computed: {
        isStrictPhoneList() {
            return /^\d{11}(, \d{11})*$/.test(this.phones);
        }
    }
}
</script>

<style scoped>
.label {
    margin-top: 2rem;
}

label {
    color: black;
}

::v-deep(.p-datatable-table-container) {
    table-layout: auto; /* Таблица подстраивается по содержимому */
    width: 100%; /* Растягиваем таблицу */
    overflow: hidden !important; /* Убираем горизонтальную прокрутку */
    white-space: nowrap;
}
</style>